import React from 'react';
import { Star } from 'lucide-react';

// Estrelas de avaliação. Mostra 5 estrelas; preenche a fração baseada em rating
// (0–5). Quando count === 0, retorna null — UI fica mais limpa sem reviews.
const RatingStars = ({ rating = 0, count = 0, size = 14, hideCount = false, hideIfEmpty = true }) => {
  const numericRating = Number(rating) || 0;
  const numericCount = Number(count) || 0;

  if (hideIfEmpty && numericCount === 0) return null;

  const full = Math.floor(numericRating);
  const hasHalf = numericRating - full >= 0.5;
  const empty = 5 - full - (hasHalf ? 1 : 0);

  return (
    <div className="inline-flex items-center gap-1 text-yellow-500">
      <div className="inline-flex items-center">
        {Array.from({ length: full }).map((_, i) => (
          <Star key={`f-${i}`} size={size} fill="currentColor" stroke="currentColor" />
        ))}
        {hasHalf && (
          <span className="relative inline-block" style={{ width: size, height: size }}>
            <Star
              size={size}
              stroke="currentColor"
              className="absolute inset-0 text-yellow-500/40"
            />
            <span
              className="absolute inset-0 overflow-hidden"
              style={{ width: '50%' }}
            >
              <Star size={size} fill="currentColor" stroke="currentColor" />
            </span>
          </span>
        )}
        {Array.from({ length: empty }).map((_, i) => (
          <Star
            key={`e-${i}`}
            size={size}
            stroke="currentColor"
            className="text-yellow-500/40"
          />
        ))}
      </div>
      {!hideCount && numericCount > 0 && (
        <span className="text-xs text-app-text-secondary ml-1">
          ({numericCount})
        </span>
      )}
    </div>
  );
};

export default RatingStars;
